'use strict';

var isExternalUrl$1 = require('../../../../../../../../_virtual/isExternalUrl.cjs');

/**
 * Determines if a URL is external by checking if it starts with http://, https://, or www.
 * 
 * Returns false for relative URLs and undefined/null values.
 */ const isExternalUrl = (url)=>{
    if (!url) return false;
    try {
        if (url.startsWith("/")) return false;
        // Check for www. or http(s)://
        return /^(https?:\/\/)|(www\.)/i.test(url);
    } catch  {
        return false;
    }
};

isExternalUrl$1.__exports.isExternalUrl = isExternalUrl;

module.exports = isExternalUrl$1.__exports;
//# sourceMappingURL=isExternalUrl.cjs.map
